module.exports = __webpack_public_path__ + "static/media/recreationyouth.95d008d9.png";